import { useSelector } from "react-redux";
import { APP_CONSTANTS } from "../../../core/config/appConstants";
import classes from "./SuccessfulVerification.module.scss";
import Container from "../../../shared/components/Container/Container";
import useTitle from "../../../core/hooks/useTitle";
import DefaultCard from "./DefaultCard";
import UpdatedCard from "./UpdatedCard";

const SuccessfulVerification = () => {
	useTitle("Verifikation abgeschlossen");
	const { caseInfo } = useSelector((state) => state.caseInfo);
	const { verificationData } = useSelector(
		(state) => state.verificationData
	);

	const isDefault = verificationData?.isDefault;
	const redirectUrl = verificationData?.redirectUrl;

	const buttons = isDefault
    ? [
        {
          label: "Zu Telekom.de",
          variant: "outline",
          onClick: () =>
            (window.location.href = APP_CONSTANTS.LINK.TELEKOM),
          size: "small",
          tabIndex: 2,
          ariaLabel: "Link zu Telekom.de",
        },
      ]
    : [];

	const icons = [
		{
			name: "success-type-standard",
			size: 64,
			color: "var(--color-success)"
		}
	];

	return (
		<Container
			title="Bestätigung erfolgreich"
			description={`Vielen Dank, dass Sie die E-Mail-Adresse ${caseInfo?.emailId} bestätigt haben.`}
			buttons={buttons}
			icon={icons[0]}
		>
			<div className={classes.cardContainer}>
				{/* Conditionally render UI based on isDefault */}
				{isDefault === false ? (
					<UpdatedCard
						redirectUrl={redirectUrl}
					/>
				) : (
					<DefaultCard />
				)}
			</div>
		</Container>
	);
};

export default SuccessfulVerification;
